<template>
    <b-container>
        <div class="d-block m-auto text-center pb-4">
            <img width="250px" src="../../assets/img/register.svg" class="img-fluid">
            <h1 class="text-center mt-4 mb-2">Register</h1>
        </div>
        <b-form v-on:submit.prevent="register">
            <b-form-group label="Name">
                <b-form-input type="text" v-model="details.name"></b-form-input>
                <b-form-invalid-feedback v-if="errors.name">{{ errors.name[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email">
                <b-form-input type="email" v-model="details.email"></b-form-input>
                <b-form-invalid-feedback v-if="errors.email">{{ errors.email[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Phone">
                <b-form-input type="tel" v-model="details.phone"></b-form-input>
                <b-form-invalid-feedback v-if="errors.phone">{{ errors.phone[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Password">
                <b-form-input type="password" v-model="details.password"></b-form-input>
                <b-form-invalid-feedback v-if="errors.password">{{ errors.password[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-button size="lg" variant="primary" block disabled v-if="loading">
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                </b-button>
                <b-button size="lg" type="submit" v-else block variant="primary">Register</b-button>
            </b-form-group>
        </b-form>
    </b-container>
</template>

<script>
    import store from './../../store';
    export default {
        name: "Register",

        data(){
            return {
                loading: false,
                details: {},
                errors: [],
                prevRoute: ''
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                console.log(from);
                vm.prevRoute = from
            })
        },


        methods: {
            register(){
                this.loading = true;
                axios.post('/register', this.details).then(response => {
                    this.$toasted.show("Registered successfully. Please register a credit card to continue.");
                    store.commit('LOGIN_USER');
                    localStorage.setItem('token', response.data.access_token);
                    this.loading = false;
                    if (this.prevRoute.name == 'loginBridge'){
                        this.$router.push({name: 'checkout'})
                    } else {
                        this.$router.push({path: '/profile/card'})
                    }
                }).catch(error => {
                    this.loading = false;
                    this.errors = error.response.data.errors;
                })
            }
        }
    }
</script>

<style scoped>

</style>